import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ConnectorsSurface } from "../workspace/connectors/ConnectorsSurface";

export const Route = createFileRoute("/connectors")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Salesko App Connectors - Messaging, Email & Contacts" },
      {
        name: "description",
        content: "Connect messaging, email, and contacts apps to your personal Agent."
      },
      { name: "robots", content: "noindex, nofollow" }
    ],
    links: [{ rel: "canonical", href: "https://salesko.ai/connectors" }]
  }),
  component: ConnectorsRoute
});

function ConnectorsRoute() {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ConnectorsSurface />
    </QueryClientProvider>
  );
}
